class Stock {
    constructor(
        public id= 0,
        public key= 0,
        public id_ingredient= 0,
        public quantitat= 0,
        public nom= "",
        public mesura= "",
        public value = "",
        public label = "",
    ) {
        this.id = id;
        this.key = key;
        this.id_ingredient = id_ingredient;
        this.quantitat = quantitat;
        this.nom = nom;
        this.mesura = mesura;
        this.value = id+"";
        this.label = nom;
    }
}

export default Stock;
